import { mapValues } from "lodash";

/**
 * Create params object according to API specs.
 */
export const createParams = (params: { [key: string]: any }) => {
    return mapValues(params, (value) => {
        if (Array.isArray(value)) {
            return value.length > 0 ? value.join(",") : null;
        }

        return value;
    });
};
